module.exports = __webpack_public_path__ + "static/img/xhsewm.f27eff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/xhsewm.png
// module id = XfBR
// module chunks = 1